import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import styled from 'styled-components';
import { scoreToColor } from '@/areas/dashboard/components/DashboardTeam.utils';

ChartJS.register(ArcElement, Tooltip);

interface SmallDoughnutProps {
  value: number; // 0-10
  color?: string;
  colorized?: boolean;
  size?: number; // px, default 42
}

const Container = styled.div<{ size: number }>`
  position: relative;
  width: ${p => p.size}px;
  height: ${p => p.size}px;
  display: inline-block;
  background: #ffffff;
  border-radius: 50%;
`;

const CenterLabel = styled.div<{ size: number }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  line-height: 1;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  color: #111827;
  pointer-events: none;
`;

const SmallDoughnut: React.FC<SmallDoughnutProps> = ({ value, color, colorized = false, size = 42 }) => {
  const val = Math.max(0, Math.min(10, Number(value) || 0));
  const fillColor = colorized ? scoreToColor(val) : color ?? '#2563eb';
  const data = {
    datasets: [
      {
        data: [val, 10 - val],
        backgroundColor: [fillColor, '#e6e6e6'],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: '65%',
    responsive: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };

  return (
    <Container size={size}>
      <Doughnut data={data as any} options={options as any} width={size} height={size} />
      <CenterLabel size={size}>{Number.isInteger(val) ? val.toString() : val.toFixed(1)}</CenterLabel>
    </Container>
  );
};

export default SmallDoughnut;
